import React from 'react'
import useSettings from '../hooks/useSettings'
import { useTheme } from '@material-ui/core'
import { THEMES } from '../constants'

function Logo(props) {
    const theme = useTheme()
    const { settings } = useSettings()

    return (
        <img
            alt="Logo"
            src={props.color === 'dark' && settings.theme === THEMES.LIGHT ? theme.logo.dark : theme.logo.light}
            style={{
                maxWidth: props.ismobile ? '85%' : props.maxwidth ? props.maxwidth : '300px',
                //width: props.ismobile ? props.maxwidth : null,
                margin: props.margin ? props.margin : null,
                maxHeight: props.maxheight ?? 30
            }}
            {...props}
        />
    )
}

export default Logo
